import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { CustomerSendingDomainQueryKeys } from "./keys";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { ISendingDomain } from "../../models/CustomerSendingDomain/CustomerSendingDomain";

export default function useCustomerSendingDomains(customerId: string) {
  const { get } = useApiHelper();

  const sendingDomains = useQuery({
    queryKey: CustomerSendingDomainQueryKeys.all(customerId),
    queryFn: () =>
      get<IDefaultResponse<ISendingDomain[]>>(
        `/customer/${customerId}/sending-domains`
      ).then((res) => res.data),
    enabled: !!customerId,
  });

  return {
    sendingDomains,
  };
}
